import { atom } from 'recoil';
import { DrawerV2Type } from '../types/drawerV2';

export const drawerV2Atom = atom<DrawerV2Type>({
  key: 'drawerV2Atom',
  default: {
    isOpen: false,
    inputs: null
  }
});
